var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { classNames } from '../../utils/style-class.utils';
import AttendanceListItem from './components/attendance-list-item/attendance-list-item';
export var AttendanceStackedList = function (_a) {
    var _b = _a.listItems, listItems = _b === void 0 ? [] : _b, className = _a.className, onChange = _a.onChange, _c = _a.scroll, scroll = _c === void 0 ? true : _c, onScroll = _a.onScroll;
    var _d = useState(listItems), renderList = _d[0], setRenderList = _d[1];
    var handleScroll = function (e) {
        var element = e.target;
        if (onScroll && element.scrollTop) {
            onScroll(element.scrollTop);
        }
    };
    useEffect(function () {
        var renderingList = JSON.parse(JSON.stringify(listItems));
        setRenderList(renderingList);
    }, [listItems]);
    var updateItemAttendance = function (currentAttendanceItem) {
        var currentItems = renderList;
        var indexOfItem = currentItems.findIndex(function (x) { return x.attenendeeId === currentAttendanceItem.attenendeeId; });
        if (indexOfItem !== -1) {
            currentItems[indexOfItem] = currentAttendanceItem;
        }
        setRenderList(currentItems);
        if (onChange) {
            onChange(currentItems);
        }
    };
    return (_jsx("div", __assign({ className: classNames(className, ' flex-1', scroll ? 'h-full overflow-auto' : ''), onScroll: function (e) { return handleScroll(e); } }, { children: renderList.map(function (item, index) { return (_jsx("div", { children: _jsx(AttendanceListItem, { item: item, onBadgeClick: function (currentAttendanceItem) {
                    return updateItemAttendance(currentAttendanceItem);
                }, className: "mt-1.5 flex flex-col" }) }, 'attendance-stackedList-listItem-' + index)); }) })));
};
export default AttendanceStackedList;
//# sourceMappingURL=attendance-stacked-list.js.map